import { Typography } from "@mui/material";
import { SectionCard } from "routes/settings/style";
import { descriptionSx } from "./Index";

export const DeleteProfile = () => {
	return (
		<>
			<SectionCard variant="outlined">
				<Typography variant="h6">Samdesk Profile</Typography>
				<Typography sx={descriptionSx}>
					We'd be sorry to see you go but if you want to delete your profile
					email data.deletion@samdesk.io with your request.
				</Typography>
			</SectionCard>
		</>
	);
};
